import React from "react"
import { Row, Col } from "react-bootstrap"
import Accordion from "react-bootstrap/Accordion"
import { SectionTitle } from "@components/Banners/SectionTitle"

export default function QuotePronosticiSeo() {
  return (
    <Col lg={12} xs={12}>
      <Row>
        <div className={"text-section"}>
          <div className={"text-div"}>
            <SectionTitle title={"PRONOSTICI CALCIO VINCENTI"} />I nostri{" "}
            <strong>pronostici gratuiti sulle partite di calcio</strong> fanno riferimento ai campionati di calcio
            europei, alle coppe e ai grandi eventi calcistici internazionali. In particolare trovi:
            <ul className="seo-list-ul">
              <li>
                <a className="seo-a-tag" href="https://www.calcio.com/scommesse/quote-pronostici/italia-serie-a">
                  Pronostici Serie A
                </a>
                : pronostici per ogni match delle giornate di campionato, con informazioni dettagliate sulle squadre e i
                calciatori.
              </li>
              <li>
                <a className="seo-a-tag" href="https://www.calcio.com/scommesse/quote-pronostici/germania-bundesliga">
                  Pronostici Bundesliga
                </a>
                : i migliori pronostici sul massimo campionato di calcio tedesco, con previsioni gratuite su tutti i
                match e dati statistici sempre aggiornati per piazzare le tue scommesse.
              </li>
              <li>
                <a className="seo-a-tag" href="https://www.calcio.com/scommesse/quote-pronostici/francia-ligue-1">
                  Pronostici Ligue 1
                </a>
                : scommetti sulle partite di calcio del campionato francese, sfruttando i nostri dati per pronostici
                under/over o per scommesse su risultato parziale o finale.
              </li>
              <li>
                <a
                  className="seo-a-tag"
                  href="https://www.calcio.com/scommesse/quote-pronostici/inghilterra-premier-league"
                >
                  Pronostici Premier League
                </a>
                : accedi ai pronostici gratuiti di uno dei campionati di calcio pi&ugrave; appassionanti d&rsquo;Europa.
                Segui i pronostici 1X2 o i pronostici goal no goal e realizza la tua schedina vincente.
              </li>
              <li>
                <a
                  className="seo-a-tag"
                  href="https://www.calcio.com/scommesse/quote-pronostici/spagna-primera-division"
                >
                  Pronostici La Liga
                </a>
                : che tu voglia giocare su un singolo match calcistico o comporre un sistema, consultando i nostri
                pronostici sul campionato di calcio spagnolo potrai affinare le tue competenze sulle scommesse sportive.
              </li>
            </ul>
          </div>
        </div>
      </Row>
      <Row>
        <div className={"text-section"}>
          <div className={"text-div"}>
            <SectionTitle title={"COME FACCIAMO LE NOSTRE PREVISIONI"} />
            <p>
              Sappiamo che sei alla ricerca di <strong>pronostici calcio sicuri</strong>, ed &egrave; per questo che noi
              di Calcio.com abbiamo costituito un team specializzato di persone attento alle nuove tendenze del calcio,
              e capace di creare previsioni gratuite basandosi su una vasta serie di dati statistici costantemente
              aggiornati.
            </p>
            <p>
              La nostra offerta non si limita ai pronostici calcio di oggi per risultati esatti, offriamo anche una{" "}
              <strong>panoramica pi&ugrave; ampia di pronostici</strong> per un&rsquo;ampia tipologia di scommesse
              calcistiche.
            </p>
            <p>
              Inoltre, trovi i <strong>confronti delle quote calcio</strong> proposte dai migliori bookmaker italiani.
              Cos&igrave; sai sempre dove &egrave; pi&ugrave; conveniente per te scommettere oggi.
            </p>
          </div>
        </div>
      </Row>
      <Row>
        <div className={"text-section"}>
          <div className={"text-div"}>
            <SectionTitle title={"TIPO DI PRONOSTICI DI SCOMMESSE SUL CALCIO"} />
            <p>
              Sai quali sono i tipi di pronostici di scommesse sul calcio pi&ugrave; comuni? Qui trovi una rapida
              carrellata, ma esaustiva, che ti guider&agrave; meglio nell&rsquo;offerta di pronostici vincenti tra cui
              potrai quello ideale per la tua puntata.
            </p>
            <ul className="seo-list-ul">
              <li>
                <strong>Pronostico vincitore</strong>: significa avere a disposizione pronostici relativi alla squadra
                che vincer&agrave; una determinata sfida o il campionato di calcio, o una coppa. I pronostici sono
                sviluppati anche per i singoli calciatori (esempio: chi vincer&agrave; il pallone d&rsquo;oro?).
              </li>
              <li>
                <strong>Pronostici Under/Over</strong>: quanti gol segneranno le squadre di calcio? Questo tipo di
                pronostico ti aiuta a selezionare il numero di gol che saranno segnati dai marcatori durante il match.
              </li>
              <li>
                <strong>Pronostici risultato parziale/finale</strong>: una guida per aiutarti a prevedere il risultato
                del primo tempo o del secondo tempo e il risultato finale della partita.
              </li>
              <li>
                <strong>Pronostici 1x2</strong>: il pi&ugrave; classico dei pronostici che non perde mai il suo fascino.
                Vince la squadra di casa, quella ospite o sar&agrave; pareggio? Le previsioni ti aiutano a centrare
                meglio il risultato.
              </li>
              <li>
                <strong>Pronostici doppia possibilit&agrave;</strong>: anche per le scommesse doppia possibilit&agrave;
                servono dei pronostici in grado di offriti indicazioni su quali possano essere gli esiti che pi&ugrave;
                si avvicineranno al risultato reale.
              </li>
              <li>
                <strong>Gol, no gol</strong>: i pronostici goal no goal possono fornirti indicazioni preziose per capire
                se le squadre in campo saranno capaci di violare la rete avversaria.
              </li>
              <li>
                <strong>Pronostici calcio d&rsquo;angolo</strong>: le partite possono giocarsi molto sui calci
                d&rsquo;angolo, ma prevedere quanti ce ne saranno &egrave; complicato senza l&rsquo;aiuto di appositi
                pronostici.
              </li>
            </ul>
          </div>
        </div>
      </Row>
      <Row>
        <div className={"text-section"}>
          <div className={"text-div"}>
            <SectionTitle title={"COME LEGGERE LE QUOTE DI CALCIO"} />
            <p>
              Come <strong>valutare le quote calcio di oggi</strong> e come scegliere quelle che ti offrono di
              pi&ugrave; in termini di potenziale vincita?
            </p>
            <p>
              Anzitutto devi sapere che le quote sono <strong>la probabilit&agrave; statistica</strong> che un certo
              evento si verifichi secondo la valutazione del bookmaker.
            </p>
            <p>
              Questo significa che se il bookmaker ritiene che il Milan sia pi&ugrave; forte dell&rsquo;Udinese,
              assegner&agrave; una quota inferiore alla vittoria del Milan (data come pi&ugrave; probabile) e una quota
              pi&ugrave; alta alla vittoria dell&rsquo;Udinese (perch&eacute; data come sfavorita).
            </p>
            <p>
              Quindi, per la partita Milan - Udinese potresti trovare che un sito di scommesse ti proponga per
              l&rsquo;1X2 le seguenti quote:
            </p>
            <ul className="seo-list-ul">
              <li>1 (1,09)</li>
              <li>X (1,57)</li>
              <li>2 (2,05)</li>
            </ul>
            <p>
              Significa che se scommetti sulla vittoria dell&rsquo;Udinese vinci di pi&ugrave;. Quanto? Il totale
              &egrave; dato dalla<strong> quota moltiplicata per il denaro scommesso</strong>. Per esempio: 2,05 x
              5&euro; = 10,25&euro;.
            </p>
            <p>
              Tieni presente che le valutazioni dei bookmaker variano in base a dove una squadra gioca, se in casa o
              come ospite. Anche le quote sul pareggio subiscono un&apos;influenza in base a dove si disputa il match.
            </p>
          </div>
        </div>
      </Row>
      <Row>
        <div className={"text-section"}>
          <div className={"text-div"}>
            <SectionTitle title={"DOMANDE FREQUENTI SU QUOTE E PRONOSTICI CALCIO"} />
            <Accordion>
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <div className={"text-div"}>Come funzionano le quote scommesse?</div>
                </Accordion.Header>
                <Accordion.Body>
                  <div className={"text-div"}>
                    La quota indica la vincita netta che potresti ottenere. Se punti 10€ con una quota 2,45, in caso di
                    vincita otterrai 10€ x 2,45 = 24,5€ di vincita.
                  </div>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  <div className={"text-div"}>Chi fa le quote delle scommesse?</div>
                </Accordion.Header>
                <Accordion.Body>
                  La figura che se ne occupa si chiama bookies ed ha il compito, per conto del bookmaker, di sviluppare
                  le quote a partire da un’ampia serie di dati statistici e di informazioni quantitative e qualitative.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2">
                <Accordion.Header>
                  <div className={"text-div"}>Come calcolare le quote scommesse?</div>
                </Accordion.Header>
                <Accordion.Body>
                  Quando calcoli le quote scommesse devi sempre tenere presente la “lavagna”, tecnicamente detto
                  “aggio”. Si tratta del margine di guadagno del bookmaker ed è una percentuale di ricarico sulle quote
                  reali. Significa che ogni bookmaker fa le sue quote trattenendo per sé un margine. Prendi il pari
                  dispari sul numero di gol nella partita Milan – Juventus. La percentuale di riuscita è del 50%, ovvero
                  quota 2,00, ma nessun bookmaker assegna la quota reale, infatti troverai: Milan (1,90) – Juventus
                  (1,80).
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="3">
                <Accordion.Header>
                  <div className={"text-div"}>Come studiare le quote scommesse</div>
                </Accordion.Header>
                <Accordion.Body>
                  Studia non solo la posizione in classifica delle squadre che si sfidano, ma anche gli altri dati
                  statistici messi a confronto: gol fatti e subiti; comportamento in casa e fuori casa; ecc.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="4">
                <Accordion.Header>
                  <div className={"text-div"}>Come utilizzo il mio bonus?</div>
                </Accordion.Header>
                <Accordion.Body>
                  Se la promozione non è vincolata a un tipo di scommessa specifica, puoi usare il bonus per puntare su
                  tutti gli eventi offerti dal bookmaker. Nel caso in cui essa sia legata a uno sport o evento
                  specifico, dovrai impiegare quel credito necessariamente in quell’ambito.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="5">
                <Accordion.Header>
                  <div className={"text-div"}>Come funzionano le quote scommesse</div>
                </Accordion.Header>
                <Accordion.Body>
                  Quando ricevi un bonus, prima di poterlo riscattare è necessario giocare la somma un certo numero di
                  volte.
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </div>
      </Row>
    </Col>
  )
}
